import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, LinkList, LinkListItem, Icon, AvatarContainer, AvatarIcon } from 'design-react-kit';
import { useAuth } from './AuthContext';
import { fetchFromBFF } from '../utility/bffUtility';


export default function SwitchOutButton() {
    const [graphData, setGraphData] = useState(null);
    const { user } = useAuth();

    async function switch_user_logout() {
        await fetchFromBFF("switch_user_logout").then(() => {
            location.href = "";
        });
    }

    async function requestProfileData() {
        setGraphData(user);
    }

    return (
        <>
            {
                graphData ? (
                    <Dropdown className="me-3">
                        <DropdownToggle color="primary">
                            <AvatarContainer>
                                <AvatarIcon color="orange">
                                    <p aria-hidden="true">
                                        {(graphData.surname ? graphData.surname.charAt() : graphData.family_name.charAt()) + (graphData.givenName ? graphData.givenName.charAt() : graphData.given_name.charAt())}
                                    </p>
                                    <span className="visually-hidden">
                                        {(graphData.surname ? graphData.surname : graphData.family_name) + " " + (graphData.givenName ? graphData.givenName : graphData.given_name)}
                                    </span>
                                </AvatarIcon>
                            </AvatarContainer>
                        </DropdownToggle>
                        <DropdownMenu>
                            <LinkList>
                                <LinkListItem>
                                    <p className='fs-6 fw-bold mb-2'>{(graphData.surname ? graphData.surname : graphData.family_name) + " " + (graphData.givenName ? graphData.givenName : graphData.given_name)}</p>
                                    <p className='mb-0'>{graphData.userPrincipalName ?? graphData.cn}</p>
                                </LinkListItem>
                                <LinkListItem inDropdown href='#'>
                                    <Icon className='me-2' color='primary' icon='it-logout' size='xs' />
                                    {
                                        <span onClick={() => switch_user_logout()}>Switch off</span>
                                    }
                                </LinkListItem>
                            </LinkList>
                        </DropdownMenu>
                    </Dropdown >
                ) : (requestProfileData(), null)
            }
        </>
    )
}
